document.addEventListener('onhowUploadComplete', function (event) {
  if (!event.isTrusted) return;

  var uploadedFileUrl = event.detail && event.detail.url;
  if (!uploadedFileUrl || typeof uploadedFileUrl !== 'string') return;
  if (!uploadedFileUrl.startsWith('https://')) return;
  if (uploadedFileUrl.startsWith('blob:')) return;

  var trusted = false;
  try {
    var host = new URL(uploadedFileUrl).hostname;
    trusted =
      host === 'cdn.shopify.com' ||
      host.endsWith('.shopifycdn.com') ||
      host.endsWith('.myshopify.com') ||
      host === window.location.hostname;
  } catch (e) {
    return;
  }
  if (!trusted) return;

  var hiddenInput = document.getElementById('onhow-upload-url');
  if (hiddenInput) {
    hiddenInput.value = uploadedFileUrl;
    hiddenInput.setAttribute('name', 'properties[Design Upload]');
  }

  var productForm = document.querySelector(
    'form[data-type="add-to-cart-form"], form[action*="/cart/add"]'
  );
  if (productForm) {
    var dest = productForm.querySelector('#uc-design-upload-prop, input[type="hidden"][name="properties[Design Upload]"]');
    if (!dest) {
      dest = document.createElement('input');
      dest.type = 'hidden';
      dest.name = 'properties[Design Upload]';
      dest.id = 'uc-design-upload-prop';
      productForm.appendChild(dest);
    }
    dest.value = uploadedFileUrl;
    dest.disabled = false;
    dest.setAttribute('name', 'properties[Design Upload]');
  }
});
